import React, { Component } from "react";

export default class Parallax extends Component {
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
    this.state = {
      speed: props.speed ? props.speed : 4,
      direction: props.direction,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.calcTranslation);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.calcTranslation);
  }

  calcTranslation = () => {
    const { disabled } = this.props;
    const { speed, direction } = this.state;
    if (!disabled) {
      let translateValue = window.scrollY / speed;
      if (translateValue < 0) {
        translateValue = 0;
      }

      let transformValue = "none";
      if (direction === "up") {
        transformValue = `translate3d(0px, ${translateValue}px, 0px)`;
      } else if (direction === "down") {
        transformValue = `translate3d(0px, -${translateValue}px, 0px)`;
      } else if (direction === "left") {
        transformValue = `translate3d(-${translateValue}px, 0px, 0px)`;
      } else if (direction === "right") {
        transformValue = `translate3d(${translateValue}px, 0px, 0px)`;
      }

      if (this.rootRef.current) {
        this.rootRef.current.style.transform = transformValue;
      }
    } else if (this.rootRef.current) {
      this.rootRef.current.style.transform = "none";
    }
  };

  render() {
    const { className } = this.props;
    return React.createElement(
      "span",
      Object.assign({}, this.props, {
        ref: this.rootRef,
        className: `parallax ${className}`,
      })
    );
  }
}
